import type BaseModel from '@/data/models/BaseModel'
import { REFLECT_METADATA } from '@/decorators/types'

export type RepositorySettings<T = string> = {
  model: typeof BaseModel
  fetch?: T
  create?: T
  bulkDeleteEndpoint?: T
  bulkUpdateEndpoint?: T
  single?: T
  update?: T
  exportEndpoint?: T
  facetEndpoint?: T
  schemaEndpoint?: T
  reorderEndpoint?: T
  bulkReorderEndpoint?: T
  pdfDownloadEndpoint?: T
  countEndpoint?: T
}

export function RepoSettings<T>(settings: RepositorySettings<T>) {
  return function <R extends { new (...args: any[]): any }>(constructor: R) {
    // save metadata on original constructor
    Reflect.defineMetadata(REFLECT_METADATA.RepoSettings, settings, constructor)

    // add settings method to prototype instead of creating new class
    constructor.prototype.settings = function () {
      return settings
    }

    // return original constructor without changes
    return constructor
  }
}

export function PublicRepo() {
  return function <T extends { new (...args: any[]): any }>(constructor: T) {
    constructor.prototype.isPublic = function () {
      return true
    }
    return constructor
  }
}
